import React from 'react'

import withPlayerGames from '../../../data/withPlayerGames'
import GameHistoryItem from './GameHistoryItem'
import {
  H2,
  CellsWrapper,
} from '../../styles'

const GameHistory = ({players}) => (
  <div>
    <H2>{players.length > 0 ? 'Previous games' : null}</H2>
    <CellsWrapper>
      {players.map(p => <GameHistoryItem key={p.game} gameId={p.game} />)}
    </CellsWrapper>
  </div>
)

export default withPlayerGames(GameHistory)



// WEBPACK FOOTER //
// ./src/views/lobby/components/GameHistory.jsx